(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen/assets/javascripts/banners.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen/assets/javascripts/banners.js');

'use strict';

const _excluded = ["classNames", "lottoDraws", "wager"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const {
  utils
} = svs.numbergames.andra_chansen;

const createBanner = (template, data) => svs.numbergames.andra_chansen_banners.createBanner(template, data);

const rowBanner = _ref => {
  var _utils$andraChansenDr;
  let {
      classNames = [],
      lottoDraws,
      wager
    } = _ref,
    options = _objectWithoutProperties(_ref, _excluded);
  const calcChances = wagerObj => ({
    chances: utils.chancesPerWager(wagerObj),
    isSubscription: wagerObj.isSubscription
  });
  const {
    render,
    update
  } = svs.numbergames.andra_chansen_banners.rowBanner(_objectSpread(_objectSpread({}, calcChances(wager)), {}, {
    endDate: (_utils$andraChansenDr = utils.andraChansenDraw()) === null || _utils$andraChansenDr === void 0 ? void 0 : _utils$andraChansenDr.endDate,
    classNames,
    isAndraChansenPeriodic: utils.isAndraChansenPeriodic(utils.andraChansenDraw())
  }, options));
  return {
    render,
    update: _ref2 => {
      let {
        wager
      } = _ref2;
      return update(_objectSpread({}, calcChances(wager)));
    }
  };
};

const infoBanner = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const draw = utils.andraChansenDraw();
  const showBannerDateSmartness = utils.showBannerDateSmartness(utils.andraChansenDraw());
  return svs.numbergames.andra_chansen_banners.infoBanner({
    draw,
    showBannerDateSmartness,
    options
  });
};


const noWinBanner = _ref3 => {
  let {
    lottoDraw,
    wager
  } = _ref3;
  const andraChansenDraw = utils.andraChansenDraw();
  return svs.numbergames.andra_chansen_banners.noWinBanner({
    andraChansenDraw,
    chancesPerLottoDraw: utils.chancesPerLottoDraw(wager),
    isInCurrentPeriod: utils.isInCurrentPeriod(andraChansenDraw, lottoDraw)
  });
};
svs.numbergames.andra_chansen.banners = {
  infoBanner,
  noWinBanner,
  rowBanner
};

 })(window);